import usePhoneExts from "./use-phone-exts";
import PhoneExtsManager from "./PhoneExtsManager";

export default usePhoneExts;

export {
  PhoneExtsManager,
};
